<template>
  <section class="w3l-contact-1 w3hny-form-btm py-5" id="contact">
    <div class="contacts-9 py-lg-5 py-md-4">
        <div class="container">
            <div class="header-sec text-center mb-5">
                <br/>
                <h1 class="title-w3l">
                    Settings
                </h1>
            </div>
            <div class="contactct-fm map-content-9">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="receiveEmail" @change="updateSettings">
                <label class="form-check-label" for="flexSwitchCheckDefault">Receive daily emails of leads</label>
              </div>
            </div>
        </div>
    </div>
</section>
</template>

<script setup lang="ts">

import type {NuxtApp} from "#app";
import Globals from "~/global";
import Notification from "../../Common/Client/Notification";

const _l: {receiveDailyEmails: number} = {receiveDailyEmails: 1};
const headers = useRequestHeaders(['cookie'])
const data = ref(_l);

const receiveEmail = ref(true);

async function updateSettings(){
  const response = await $fetch.raw(`/api/users/settings`, {
    method: "PUT",
    headers,
    body: JSON.stringify({receiveEmail: receiveEmail.value}),
    ignoreResponseError: true
  });
  const code: number = response.status;
  if (code !== 200)
    Notification.error(`Error`, `Could not update settings`);
  else
    Notification.success(`Success`, `Settings updated successfully`);
}

const asyncData = await useAsyncData(async function (ctx?: NuxtApp | undefined): Promise<unknown> {
  const response = await $fetch.raw(`/api/users/settings`, {
    method: "GET",
    headers,
    ignoreResponseError: true
  });
  return response._data;
});

//@ts-ignore
data.value = asyncData.data.value;
receiveEmail.value = data.value.receiveDailyEmails === 1;

useHead({
  //@ts-ignore
  title: `ForumLeadsFinder – Settings`,
  meta: [
    {
      name: "description",
      //@ts-ignore
      content: `ForumLeadsFinder - Change your email notification settings`
    }
  ]
});
</script>

<style scoped>

</style>